import axios from 'axios';
import apiConfig from '../config/apiConfig';

const API_BASE_URL = apiConfig.BASE_URL;

// Get all authors (multilingual support)
export const getAllAuthors = async (params = {}) => {
  try {
    const { lang, region } = params;
    const queryParams = new URLSearchParams();
    if (lang) queryParams.append('lang', lang);
    if (region) queryParams.append('region', region);
    
    const url = queryParams.toString() 
      ? `${API_BASE_URL}/authors?${queryParams.toString()}`
      : `${API_BASE_URL}/authors`;
    
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching authors:', error);
    throw error;
  }
};

// Get author by slug (multilingual support with region)
export const getAuthorBySlug = async (slug, lang = null, region = null) => {
  try {
    const params = {};
    if (lang) params.lang = lang;
    if (region) params.region = region;
    const response = await axios.get(`${API_BASE_URL}/authors/${slug}`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching author by slug:', error);
    throw error;
  }
};

// Get articles by author (multilingual support)
export const getAuthorArticles = async (slug, params = {}) => {
  try {
    const { page = 1, limit = 10, lang, region, sort, category } = params;
    const queryParams = new URLSearchParams();
    
    if (page) queryParams.append('page', page);
    if (limit) queryParams.append('limit', limit);
    if (lang) queryParams.append('lang', lang);
    if (region) queryParams.append('region', region);
    if (sort) queryParams.append('sort', sort);
    if (category) queryParams.append('category', category);
    
    const response = await axios.get(`${API_BASE_URL}/authors/${slug}/articles?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching author articles:', error);
    throw error;
  }
};

// Create author (Admin only)
export const createAuthor = async (authorData) => {
  try {
    const token = getAuthToken();
    const response = await axios.post(`${API_BASE_URL}/authors`, authorData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating author:', error);
    throw error;
  }
};

// Update author (Admin only)
export const updateAuthor = async (id, authorData) => {
  try {
    const token = getAuthToken();
    const response = await axios.put(`${API_BASE_URL}/authors/${id}`, authorData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating author:', error);
    throw error;
  }
};

// Delete author (Admin only)
export const deleteAuthor = async (id) => {
  try {
    const token = getAuthToken();
    const response = await axios.delete(`${API_BASE_URL}/authors/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting author:', error);
    throw error;
  }
};

// Helper function to get auth token
const getAuthToken = () => {
  try {
    const persistRoot = localStorage.getItem('persist:root');
    if (persistRoot) {
      const parsed = JSON.parse(persistRoot);
      if (parsed.auth) {
        const authState = JSON.parse(parsed.auth);
        return authState.token;
      }
    }
  } catch (e) {
    console.warn('Could not read token from redux-persist:', e);
  }
  
  return localStorage.getItem('token') || sessionStorage.getItem('token');
};


